import Vue from 'vue';
import Colcade from 'colcade';

import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

Vue.component('columns-component', {
    data() {
        return {
        }
    },

    mounted() {
        this.$nextTick(() => {
            if (!this.$el.querySelector('.block-columns') && this.$el.classList.contains('block-columns')) {
                this.initColumns(this.$el);
                return;
            }
    
            if (this.$el.querySelector('.block-columns') !== null) {
                this.initColumns(this.$el.querySelector('.block-columns'));
            }
        });
    },

    methods: {
        initColumns(blocksEl) {
            this.colcade = new Colcade(blocksEl, {
                columns: '.grid-col',
                items: '.block-columns__item'
            });

            gsap.delayedCall(0.3, () => {
                ScrollTrigger.refresh();
            });
        }
    }
});